import {
  Product,
  ProductBrandListResponseData,
  ProductCaseListResponseData,
  ProductistResponseData,
  RecommednProductistResponseData,
} from '@/interface/product';
import { SettledValidCode, Settled } from '@/interface/settled';
import { nextApiRequest } from '@/utils/request';

export async function getProductList(params: { pageIndex: number; pageSize: number }) {
  return nextApiRequest.request<ProductistResponseData>({
    method: 'get',
    url: '/v1/boxproduct',
    params,
  });
}

export async function getProductDetail(boxProductId: string) {
  return nextApiRequest.request<Product>({
    method: 'get',
    url: `/v1/boxproduct/${boxProductId}`,
  });
}

export async function getProductFunction(boxProductId: string) {
  return nextApiRequest.request<{ boxProductId: string; functionContent?: string }>({
    method: 'get',
    url: `/v1/boxproductfunction/${boxProductId}`,
  });
}

export async function getProductPrice(boxProductId: string) {
  return nextApiRequest.request<{ boxProductId: string; priceContent?: string }>({
    method: 'get',
    url: `/v1/boxproductprice/${boxProductId}`,
  });
}

export async function getProductCaseList(params: { boxProductId: string; pageIndex: number; pageSize: number }) {
  return nextApiRequest.request<ProductCaseListResponseData>({
    method: 'get',
    url: `/v1/boxproductcase/list_by_product/${params.boxProductId}`,
    params,
  });
}

export async function getProductCaseDetails(boxProductCaseId: string) {
  return nextApiRequest.request<ProductCaseListResponseData>({
    method: 'get',
    url: `/v1/boxproductcase/${boxProductCaseId}`,
  });
}

export async function getProductBrandList(params: { boxProductId: string; pageIndex: number; pageSize: number }) {
  return nextApiRequest.request<ProductBrandListResponseData>({
    method: 'get',
    url: `/v1/boxproductbrand/list_by_product/${params.boxProductId}`,
    params,
  });
}

export async function getRecommendProductList(params: { pageIndex: number; pageSize: number }) {
  return nextApiRequest.request<RecommednProductistResponseData>({
    method: 'get',
    url: '/v1/boxrecommendproduct',
    params,
  });
}

export async function getOtherCaseList(params: {
  boxProductCaseId: string;
  boxProductId: string;
  pageIndex: number;
  pageSize: number;
}) {
  return nextApiRequest.request<RecommednProductistResponseData>({
    method: 'get',
    url: '/v1/boxproductcase/other_list',
    params,
  });
}

export async function queryHasUserConsulted(params: { boxProductId: string }) {
  return nextApiRequest.request<{ hasSubmit: boolean }>({
    method: 'get',
    url: '/v1/boxaskprice/user',
    params,
    headers: { noAuthHandle: true },
  });
}
export async function postSendValidCode(data) {
  return nextApiRequest.request<SettledValidCode>({
    method: 'post',
    url: '/v1/boxaskprice/valid_code',
    data,
  });
}

export async function postConsult(data) {
  return nextApiRequest.request<Settled>({
    method: 'post',
    url: '/v1/boxaskprice',
    data,
  });
}
